import { ReactNode } from 'react';
import { Card, Space, Typography } from 'antd';
import cs from 'classnames';

import stylesCard from './styles.module.scss';

const { Title } = Typography;

interface ICardDataBase {
    children?: ReactNode;
    title?: string;
    style?: {
        [x: string]: string | boolean | number;
    };
    innerTitleContentStyle?: {
        [x: string]: string | boolean | number;
    };
    action?: ReactNode[];
}

const CardDataBase = ({
    children,
    title,
    style,
    action,
    innerTitleContentStyle,
}: ICardDataBase) => (
    <Card className={cs(stylesCard.content)} style={style}>
        {
            title && (
                <Space size={8} style={innerTitleContentStyle}>
                    <Title level={4} style={{ marginBottom: action ? 0 : 24 }}>{title}</Title>
                    {action && action.map((act) => act)}
                </Space>
            )
        }
        {children}
    </Card>
);

export default CardDataBase;
